import { createTheme } from "@mui/material/styles";

// RETRO-FUTURISTIC SCHOOL PALETTE — No gradients, solid vibrant colors
const CREAM    = "#FFF8F0";
const NAVY     = "#1B1F3B";
const CORAL    = "#FF6B6B";
const YELLOW   = "#FFD93D";
const TEAL     = "#06D6A0";
const PURPLE   = "#845EF7";
const ORANGE   = "#FF9F1C";
const SKY      = "#74C0FC";

const theme = createTheme({
  palette: {
    mode: "light",
    primary:   { main: NAVY,   light: "#2E3461", dark: "#0D1026" },
    secondary: { main: CORAL,  light: "#FF8E8E", dark: "#E04545" },
    success:   { main: TEAL,   light: "#38E8B5", dark: "#04A87C" },
    info:      { main: SKY,    light: "#A5D8FF", dark: "#4A9FDC" },
    warning:   { main: YELLOW, light: "#FFE680", dark: "#E0B800" },
    background: { default: CREAM, paper: "#FFFFFF" },
    text: { primary: NAVY, secondary: "#4A4E6D" },
  },
  shape: { borderRadius: 16 },
  typography: {
    fontFamily: "'Nunito', 'Space Grotesk', sans-serif",
    h1: { fontFamily: "'Fredoka One', cursive", fontWeight: 400, letterSpacing: "0.01em", lineHeight: 1.1 },
    h2: { fontFamily: "'Fredoka One', cursive", fontWeight: 400, letterSpacing: "0.01em", lineHeight: 1.15 },
    h3: { fontFamily: "'Fredoka One', cursive", fontWeight: 400, lineHeight: 1.2 },
    h4: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, lineHeight: 1.2 },
    h5: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700 },
    h6: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700 },
    body1: { fontFamily: "'Nunito', sans-serif", fontWeight: 600 },
    body2: { fontFamily: "'Nunito', sans-serif", fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 800, fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "0.03em" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: "2.5px solid " + NAVY,
          boxShadow: "4px 4px 0px " + NAVY,
          transition: "all 0.15s ease",
          "&:hover": {
            transform: "translate(-2px, -2px)",
            boxShadow: "6px 6px 0px " + NAVY,
          },
          "&:active": {
            transform: "translate(2px, 2px)",
            boxShadow: "2px 2px 0px " + NAVY,
          },
        },
        contained: {
          backgroundColor: YELLOW,
          color: NAVY,
          "&:hover": { backgroundColor: "#FFE566" },
        },
        containedSecondary: {
          backgroundColor: CORAL,
          color: "#fff",
          border: "2.5px solid " + NAVY,
          "&:hover": { backgroundColor: "#FF8080" },
        },
        containedSuccess: {
          backgroundColor: TEAL,
          color: NAVY,
          "&:hover": { backgroundColor: "#2AE8B5" },
        },
        outlined: {
          borderWidth: "2.5px",
          "&:hover": { borderWidth: "2.5px" },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "2.5px solid " + NAVY,
          boxShadow: "5px 5px 0px " + NAVY,
          background: "#fff",
          transition: "all 0.2s ease",
          "&:hover": {
            transform: "translate(-2px, -2px)",
            boxShadow: "7px 7px 0px " + NAVY,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 800,
          border: "2px solid " + NAVY,
          fontFamily: "'Space Grotesk', sans-serif",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
  },
});

export default theme;
